// extracted by mini-css-extract-plugin
export default {"price":"m8-z","priceRow":"n8-z","onSale":"o8-z","msrpLabelPrice":"p8-z","msrpLabel":"q8-z","originalPrice":"r8-z","percentOff":"s8-z"};